import Quill from 'quill'

const Parchment = Quill.import('parchment')

const BlockLineHeightAttributor = new Parchment.Attributor.Style('blockLineHeight', 'line-height', {
    scope: Parchment.Scope.BLOCK
});

export { BlockLineHeightAttributor }
